import { createSlice } from '@reduxjs/toolkit';

import { getPolicyListForPayer } from 'api/clientAPI';
import { handleError } from 'services/Error';

export const clientSlice = createSlice({
    name: 'client',
    initialState: {
        policyListMap: {},
    },
    reducers: {
        setPolicyList(state, action) {
            return {
                ...state,
                policyListMap: {
                    ...state.policyListMap,
                    [action.payload.payerId]: action.payload.policyList,
                },
            };
        },
    },
});

export const { setPolicyList } = clientSlice.actions;

export const fetchPolicyListForPayer = (payerId, npi) => async (dispatch) => {
    try {
        const policyData = await getPolicyListForPayer(payerId, npi);
        const policyList = {};
        policyData.forEach((policy) => {
            if (!policyList[policy.product_oid]) {
                policyList[policy.product_oid] = [];
            }
            policyList[policy.product_oid].push(policy.diagnosis_oid);
        });
        dispatch(setPolicyList({ payerId, policyList }));
    } catch (err) {
        handleError('An error occurred retrieving clinical policy list.', err);
    }
};
